import { useMemo, createElement } from '@max/max';
import Text from '@hfe/max-text';
import LinearGradientText from "../LinearGradientText/index.web";
import './index.scss';
function LinearGradientTitle(props) {
    const titleInfos = props.titleInfos || [];
    const renderTitle = useMemo(() => {
        return titleInfos.map((item, index) => {
            const type = item.type;
            if (type === 'landmark') {
                return <LinearGradientText key={index} text={item.content}/>;
            }
            else {
                return <Text className="content-title-text" key={index}>{item.content}</Text>;
            }
        });
    }, [titleInfos]);
    return <>
      {renderTitle}
    </>;
}
export default LinearGradientTitle;
